import { createReducer } from '@reduxjs/toolkit'
import { PortfolioDetailsItem, PortfolioTimeline } from '../../models/Portfolio';
import { loadPortfolioDetails, setTab, setTimeline } from '../actions/portfolioDetails';

export interface PortfolioDetailsReducer {
    portfolio: PortfolioDetailsItem | undefined;
    tab: number;
    timeline: PortfolioTimeline;
}

const initialState: PortfolioDetailsReducer = {
    portfolio: undefined,
    tab: 0,
    timeline: PortfolioTimeline.ThreeMonth
}

const portfolioDetailsReducer = createReducer<PortfolioDetailsReducer>(initialState, (builder) => {
    builder.addCase(setTab, (state, action) => {
        state.tab = action.payload;
    })
    builder.addCase(setTimeline, (state, action) => {
        state.timeline = action.payload;
    })
    builder.addCase(loadPortfolioDetails.pending, (state) => {
        state.portfolio = undefined;
        state.tab = 0;
        state.timeline = PortfolioTimeline.ThreeMonth;
    });
    builder.addCase(loadPortfolioDetails.fulfilled, (state, action) => {
        state.portfolio = action.payload;
    });
});

export default portfolioDetailsReducer;
